import { render, staticRenderFns } from "./FeaturedPlayer.vue?vue&type=template&id=13110f70&scoped=true&"
import script from "./FeaturedPlayer.vue?vue&type=script&lang=js&"
export * from "./FeaturedPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPlayer.vue?vue&type=style&index=0&id=13110f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13110f70",
  null
  
)

export default component.exports